/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ContinueAction/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ContinueAction({
  children,
  viewPath = "/DesignSystem/ManualAutomations/Content/Content/ContinueAction",
  onSubmit,
  isDisabled
  
}) {
let selectedSubmitData = fromData.useDataSubmit({ viewPath,
context: 'selected',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let constantData = 'pre'
let selectedTriggerTypeValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'trigger_type',
})
let aggregateData = fromAggregate.equals(constantData, selectedTriggerTypeValueData)
let selectedValueData = fromData.useDataValue({ viewPath,
context: 'selected',
})
let manualActionExecutionsValueData = fromData.useDataValue({ viewPath,
context: 'manual_action_executions',
})
let aggregateData1 = fromHelpers.isLast(selectedValueData, manualActionExecutionsValueData)
  return (<React.Fragment
>
<div
  data-testid="ContinueAction.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 data="selected"
 onClick={selectedSubmitData}
 disabled={isDisabled}
 marginLeft={dtSpaceXs}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text={aggregateData ? "Go back and complete" : aggregateData1 ? "Submit" : "Continue"}
 data={aggregateData ? "selected" : "'pre'"}
 data={aggregateData ? "selected" : "selected.trigger_type"}
 aggregate={aggregateData1 ? "helpers.js isLast" : "/Data/aggregate.js equals"}
/>
)}
</TysiaButton>
</div>
{children}
</React.Fragment>)
}